<script lang="ts">
  import { onMount } from "svelte";
  import { TableHeaderField, TableDataField, type ITableField } from "../../components/Table";
  import Button from "../../components/Button.svelte";
  import NumberInputModal from "../../components/Modal/NumberInputModal.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { weightItemDtoFields } from "../../utils/TableFields/weight-item-dto.fields";
  import {
    loading,
    filter,
    records,
    pagination,
    initList,
    search,
    onPageChange,
    saveManualWeight,
    printLabelsRange,
    printRange,
    onDateFilterChanged,
  } from "./weight-label.store";
  import type { IWeightLabelDTO } from "../../services/DTO/weight-label-dto";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import TablePaginator from "../../components/Table/TablePaginator.svelte";
  import Label from "../../components/Form/Label.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import DateInputString from "../../components/Form/Fields/DateInputString.svelte";

  let colspanValue = weightItemDtoFields.length + 1;
  let visibleFields = weightItemDtoFields;

  let weightModalOpen = false;
  let weightNumber = 0;
  let weightRecord: IWeightLabelDTO | null = null;

  function renderField(field: ITableField<any>, record: any) {
    if (field.render != null && typeof field.render === "function") {
      return field.render(record);
    }
    return record[field.name];
  }

  function confirmImmission(event: CustomEvent) {
    if (!!weightRecord) {
      let item = Object.assign({}, weightRecord);
      let weight: number = event.detail;
      if (weight > 0) {
        saveManualWeight(item, weight);
      }
    }
    weightRecord = null;
  }

  function declineImmission() {
    weightRecord = null;
  }

  function weighItem(item: IWeightLabelDTO) {
    weightRecord = item;
    weightNumber = 0; // make sure it's zero
    weightModalOpen = true;
  }

  onMount(initList);
</script>

<MainLayout>
  <NumberInputModal
    title="Peso Manuale"
    message="Specificare il peso."
    bind:numberValue={weightNumber}
    bind:open={weightModalOpen}
    on:confirm={confirmImmission}
    on:decline={declineImmission}
  />

  <SearchHeader
    entitySingular="prodotto"
    entityPlural="prodotti"
    searchFieldVisible={false}
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  >
    <div slot="search" class="level-item weight-label-search-box">
      <!--
      <div style="min-width: 20rem; margin-left: 3rem;">
        <div class="field has-addons">
          <p class="control"></p>
        </div>
      </div>
      -->
      <div style="min-width: 5rem;">
        <DateInputString name="" placeholder="Data Macellazione" required={false} value={$filter.criteria.refDate} on:select={onDateFilterChanged} />
      </div>

      <div style="min-width: 5rem;">
        <Label>Mostra tutti</Label>
      </div>
      <div style="min-width: 5rem;">
        <Switch name="" altText="Mostra tutti o solo da stampare" bind:value={$filter.criteria.showAll} on:toggle={search} />
      </div>
      <!--
      <div style="min-width: 5rem;">
        <Button on:click={downloadDailySlaughterReport}>Stampa report</Button>
      </div>
      -->
    </div>
    <div slot="additional" class="level-right slaughter-item-print-range">
      <div class="level-item">
        <p class="control" style="margin-right: .5rem;">Stampa progressivi:</p>
        <p class="control">
          <NumberInput name="" minValue={0} bind:value={$printRange.minValue} />
        </p>
        <p class="control" style="margin: 0 .5rem;">&mdash;</p>
        <p class="control">
          <NumberInput name="" minValue={0} bind:value={$printRange.maxValue} />
        </p>
        <p class="control" style="margin: 0 .5rem;">&nbsp;</p>
        <p class="control">
          <Button on:click={printLabelsRange} altText="Stampa le etichette nell'intervallo di numero progressivo indicato.">
            <span>Stampa</span>
          </Button>
        </p>
      </div>
    </div>
  </SearchHeader>

  <table class="table is-striped is-fullwidth table-base">
    <thead>
      <tr>
        {#each visibleFields as field}
          <TableHeaderField klass={field.titleClass || ""} sortable={field.sortable}>
            {field.title}
          </TableHeaderField>
        {/each}

        <TableHeaderField klass="table-buttons"></TableHeaderField>
      </tr>
    </thead>

    <tbody>
      {#if $loading == false}
        {#if $records.length == 0}
          <tr class="table-no-data">
            <td colspan={colspanValue}> nessun elemento da visualizzare </td>
          </tr>
        {:else}
          {#each $records as record}
            <tr>
              {#each visibleFields as field}
                <TableDataField klass={field.dataClass || ""}>
                  {@html renderField(field, record)}
                </TableDataField>
              {/each}

              <TableDataField klass="has-text-centered">
                <Button
                  klass="is-warning"
                  disabled={record.slaughterWeight.weighted == 1 || record.slaughterWeight.printed == 1}
                  on:click={(_) => weighItem(record)}>Peso Manuale</Button
                >
              </TableDataField>
            </tr>
          {/each}
        {/if}
      {:else}
        <tr class="table-no-data">
          <td colspan={colspanValue}>
            <div class="table-loader" />
          </td>
        </tr>
      {/if}
    </tbody>
  </table>

  <TablePaginator pagination={$pagination} on:pageChange={onPageChange} />
</MainLayout>

<style>
  .table-base {
    margin-top: 1.5rem;
  }

  .table-base tr.table-no-data {
    transition: all 1s linear;
  }
  .weight-label-search-box {
    display: flex;
    flex-direction: row;
  }
  .weight-label-search-box div {
    padding-right: 0.75rem;
  }
</style>
